module.exports = __webpack_public_path__ + "static/media/hi_orangeBlueBlue.84b43570.svg";